var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
import { cleanObject, deeplySetProperty, getActivationProps, getFavoritesProps, getPageLoginState, getTimePartingInfo, handleAnalytics, hasEntitlementOverride, isCollection, isContinuousPlay, isDeeplink, isEndcard, isFind, isHome, isLive, isMovieDetail, isSearch, isSeriesDetail, isVodSection, noop, omitProperties, pushProfileIdsToGoogleDataLayer, recursiveMerge, } from "./CommonHelper";
import { APP_VERSION, Events, EventTypeMap, EventTypes, LABEL_TV_PROVIDER_SIGN_OUT_PAGE_VIEW, OPTIMIZELY_SEGMENT_LOCAL_STORAGE, PageEvents, PageNames, PAGE_NAME_PREFIX, SECOND_SCREEN_ANONYMOUS_ID, SECOND_SCREEN_PROFILE_ID, SegmentBannerTypes, SegmentEventStrings, SegmentEventTypes, SegmentPageStartSources, SegmentPlayerContextStrings, SegmentProfileIdCookies, SegmentReferrerProps, SegmentSources, SEGMENT_DEVICE_ID_COOKIE, SEGMENT_PAGE_TYPE_CCPA, SESSION_STORAGE_REFERRER_TRACKING, TrackEvents, } from "./Enums";
import { setUtagPagePropsCallback } from "./TealiumHelper";
var COLLECTION_CTA_PAGE_VIEW = PageEvents.COLLECTION_CTA_PAGE_VIEW, LIVE_LOC_REQ_PAGE_VIEW = PageEvents.LIVE_LOC_REQ_PAGE_VIEW, TV_PROVIDER_SIGN_OUT_PAGE_VIEW = PageEvents.TV_PROVIDER_SIGN_OUT_PAGE_VIEW;
var COLLECTION = PageNames.COLLECTION, COLLECTION_HOME = PageNames.COLLECTION_HOME, COLLECTION_LIVE_TV = PageNames.COLLECTION_LIVE_TV, COLLECTION_LOCAL = PageNames.COLLECTION_LOCAL, COLLECTION_NEWS = PageNames.COLLECTION_NEWS, CONTINUOUS_PLAY = PageNames.CONTINUOUS_PLAY, DEEPLINK = PageNames.DEEPLINK, DETAIL = PageNames.DETAIL, ENDCARD = PageNames.ENDCARD, FIND = PageNames.FIND, HOME = PageNames.HOME, LIVE = PageNames.LIVE, MOVIE_DETAIL = PageNames.MOVIE_DETAIL, MOVIES = PageNames.MOVIES, NETWORK_DETAIL = PageNames.NETWORK_DETAIL, PLAYER = PageNames.PLAYER, SEARCH = PageNames.SEARCH, SERIES_DETAIL = PageNames.SERIES_DETAIL, SHOWS = PageNames.SHOWS, VOD_SECTION = PageNames.VOD_SECTION;
var FAT = SegmentBannerTypes.FAT, MARKETING_VIDEO = SegmentBannerTypes.MARKETING_VIDEO, SKINNY = SegmentBannerTypes.SKINNY;
var NAME = SegmentReferrerProps.NAME, NONE = SegmentReferrerProps.NONE, POSITION = SegmentReferrerProps.POSITION, TYPE = SegmentReferrerProps.TYPE;
var MVPDINCOMPLETE = SegmentPageStartSources.MVPDINCOMPLETE, PP_EXPIRATION = SegmentPageStartSources.PP_EXPIRATION, PP_SIGNIN = SegmentPageStartSources.PP_SIGNIN, SETTINGS = SegmentPageStartSources.SETTINGS;
var AUTH_SUCCESS_EVENT = TrackEvents.AUTH_SUCCESS_EVENT, TV_PROVIDER_FEAT_LIST = TrackEvents.TV_PROVIDER_FEAT_LIST;
var appVersion = Version !== null && Version !== void 0 ? Version : "";
var appBuild = BuildNumber !== null && BuildNumber !== void 0 ? BuildNumber : "";
var businessUnit = (_d = (_c = (_b = window.ExternalConfig) === null || _b === void 0 ? void 0 : _b.analytics) === null || _c === void 0 ? void 0 : _c.primary_business_unit) !== null && _d !== void 0 ? _d : "fng";
var secondaryBusinessUnit = (_g = (_f = (_e = window.ExternalConfig) === null || _e === void 0 ? void 0 : _e.brand) === null || _f === void 0 ? void 0 : _f.businessUnit) !== null && _g !== void 0 ? _g : "fox";
var appName = (_k = (_j = (_h = window.ExternalConfig) === null || _h === void 0 ? void 0 : _h.analytics) === null || _j === void 0 ? void 0 : _j.app_name) !== null && _k !== void 0 ? _k : "foxnow";
var appPlatform = (_o = (_m = (_l = window.ExternalConfig) === null || _l === void 0 ? void 0 : _l.analytics) === null || _m === void 0 ? void 0 : _m.app_platform) !== null && _o !== void 0 ? _o : "web";
export var defaultCampaignValues = {
    campaign_tracking_code: undefined,
    campaign_organization: undefined,
    campaign_marketing_channel: undefined,
    campaign_source: undefined,
    campaign_name: undefined,
    campaign_additional: undefined,
    campaign_agency: undefined,
};
export var defaultGlobalPageProperties = {
    primary_business_unit: businessUnit,
    secondary_business_unit: secondaryBusinessUnit,
    app_name: appName,
    app_platform: appPlatform,
    app_version: appVersion,
    app_build: appBuild || undefined,
    page_name: undefined,
    page_type: undefined,
    page_login_state: undefined,
};
export var defaultVideoProperties = {
    session_id: undefined,
    position: undefined,
    total_length: undefined,
    livestream: undefined,
    method: undefined,
    asset_id: undefined,
    pod_id: undefined,
    title: undefined,
    season: undefined,
    episode: undefined,
    program: undefined,
    content_asset_id: undefined,
    content_pod_id: undefined,
    content_pod_ids: undefined,
    video_asset_title: undefined,
    video_external_id: undefined,
    video_genre: undefined,
    video_is_livestream: undefined,
    video_player_state: undefined,
    video_player_content_type: undefined,
    video_asset_id: undefined,
    video_primary_business_unit: businessUnit,
    video_secondary_business_unit: secondaryBusinessUnit,
    video_fox_profile: undefined,
    video_content_length: undefined,
    video_content_type: undefined,
    video_content_length_format: undefined,
    video_station_id: undefined,
    video_network: undefined,
    video_sports_type: undefined,
    video_seconds_viewed: undefined,
};
export var referrerPageMap = (_a = {},
    _a[COLLECTION] = "Collection",
    _a[DETAIL] = "Detail Page",
    _a[FIND] = "Find",
    _a[LIVE] = "Live Section",
    _a[MOVIE_DETAIL] = "Detail Page",
    _a[SEARCH] = "Search",
    _a[SERIES_DETAIL] = "Detail Page",
    _a.PAGE_NAME_CONTINUOUS_PLAY = CONTINUOUS_PLAY,
    _a.PAGE_NAME_DEEPLINK = DEEPLINK,
    _a.PAGE_NAME_ENDCARD = ENDCARD,
    _a.PAGE_NAME_HOME = HOME,
    _a.PAGE_NAME_MOVIES = MOVIES,
    _a.PAGE_NAME_NETWORK_DETAIL = NETWORK_DETAIL,
    _a.PAGE_NAME_PLAYER = PLAYER,
    _a.PAGE_NAME_SHOWS = SHOWS,
    _a.PAGE_NAME_VOD_SECTION = VOD_SECTION,
    _a);
export var callIdentifyEvent = function (_a) {
    var _b;
    var userId = _a.userId, segCompProps = _a.segCompProps;
    var segmentCampaignCodes = getDataLayerCampaignCodes();
    var contextData = getContextTraits();
    var contextTraits = (_b = contextData.traits) !== null && _b !== void 0 ? _b : {};
    var props = __assign(__assign(__assign({}, contextTraits), segCompProps), segmentCampaignCodes);
    var cleanedProps = cleanObject(props);
    var cb = function () {
        return deeplySetProperty(window, "context.segment.identified", true);
    };
    fireEvent({ eventType: "identify", userId: userId, props: props, cb: cb });
};
// TODO: refactor callPageEvent
export var callPageEvent = function (_a) {
    var _b, _c, _d, _e;
    var eventName = _a.eventName, props = _a.props, pageName = _a.pageName, _f = _a.featureFlag, featureFlag = _f === void 0 ? false : _f;
    var featureFlagValue = featureFlag || LeapfrogPageEventsEnabled;
    if (isEventEnabled(featureFlagValue))
        return;
    var pageTestName = (_b = window === null || window === void 0 ? void 0 : window.amplitude) === null || _b === void 0 ? void 0 : _b.pageTestName;
    var callSign = props.callSign, favoritesContentList = props.favoritesContentList, favoritesContentLength = props.favoritesContentLength, pageCollectionLength = props.pageCollectionLength, pageCollectionTitle = props.pageCollectionTitle, pageCollectionType = props.pageCollectionType, pageTitle = props.pageTitle, pageType = props.pageType;
    // todo - move this to its own function
    // update tealium utag_data for use across app and player
    if (callSign) {
        deeplySetProperty(window, "utag_data.call_sign", callSign);
        var currentPageName = (_d = (_c = window.utag_data) === null || _c === void 0 ? void 0 : _c.page_name) !== null && _d !== void 0 ? _d : null;
        if (currentPageName === null || currentPageName === void 0 ? void 0 : currentPageName.includes("local"))
            deeplySetProperty(window, "utag_data.page_name", currentPageName + ":" + callSign);
    }
    else if ((_e = window.utag_data) === null || _e === void 0 ? void 0 : _e.call_sign) {
        deeplySetProperty(window, "utag_data.call_sign", null);
        deeplySetProperty(window, "utag_data.page_name", PAGE_NAME_PREFIX + ":" + pageName);
    }
    var customProps = cleanObject({
        page_name: generatePageName({ pageName: pageName }),
        page_content_title: pageTitle,
        page_type: pageType,
        page_test_name: pageTestName,
        favorites_content_list: favoritesContentList,
        favorites_content_length: favoritesContentLength,
        page_collection_length: pageCollectionLength,
        page_collection_title: pageCollectionTitle,
        page_collection_type: pageCollectionType,
    });
    fireEvent({
        cb: setUtagPagePropsCallback(customProps.page_name, customProps.page_type),
        eventType: SegmentEventTypes.PAGE_EVENT,
        eventName: eventName,
        props: customProps,
    });
};
export var callPlayerEvent = function (_a) {
    var eventName = _a.eventName, props = _a.props;
    var trackingProps = getDefaultEventProps({ props: props });
    var campaignTraits = getCampaignValues();
    var mergedProps = recursiveMerge(defaultVideoProperties, defaultGlobalPageProperties, campaignTraits, trackingProps);
    fireEvent({
        eventType: SegmentEventTypes.TRACK_EVENT,
        eventName: eventName,
        props: mergedProps,
    });
};
export var checkIfAnalyticsLoaded = function () { var _a, _b, _c; return (_c = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.segment) === null || _b === void 0 ? void 0 : _b.loaded) !== null && _c !== void 0 ? _c : false; };
export var concatSourceNameData = function (_a) {
    var _b, _c, _d, _e;
    var data = _a.data;
    // this will eventually be used for end slate as well
    var seriesName = (_b = data === null || data === void 0 ? void 0 : data.seriesName) !== null && _b !== void 0 ? _b : "no series name";
    var seasonNumber = (_c = data === null || data === void 0 ? void 0 : data.seasonNumber) !== null && _c !== void 0 ? _c : "no season";
    var episodeNumber = (_d = data === null || data === void 0 ? void 0 : data.episodeNumber) !== null && _d !== void 0 ? _d : "no episode";
    var name = (_e = data === null || data === void 0 ? void 0 : data.name) !== null && _e !== void 0 ? _e : "no name";
    return seriesName + "|" + seasonNumber + "|" + episodeNumber + "|" + name;
};
export var fireCallbackWhenReady = function (cb) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    // Check if Segment loaded and identify event fired
    var analyticsLoaded = checkIfAnalyticsLoaded();
    var ajs_anonymous_id = (_e = (_c = (_b = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b["cp.ajs_anonymous_id"]) !== null && _c !== void 0 ? _c : (_d = window.utag_data) === null || _d === void 0 ? void 0 : _d.ajs_anonymous_id) !== null && _e !== void 0 ? _e : null;
    var identified = (_l = (_j = (_h = (_g = (_f = window.context) === null || _f === void 0 ? void 0 : _f.segment) === null || _g === void 0 ? void 0 : _g.identified) !== null && _h !== void 0 ? _h : window.secondScreenFlow) !== null && _j !== void 0 ? _j : (_k = window.utag_data) === null || _k === void 0 ? void 0 : _k.isFreemium) !== null && _l !== void 0 ? _l : ajs_anonymous_id;
    if (analyticsLoaded && identified) {
        // If analytics loaded & identify has fired, fire segment event after
        cb();
    }
    else {
        setTimeout(function () { return fireCallbackWhenReady(cb); });
    }
};
export var fireEvent = function (_a) {
    var _b, _c, _d;
    var cb = _a.cb, _e = _a.context, context = _e === void 0 ? {} : _e, eventName = _a.eventName, eventType = _a.eventType, _f = _a.props, props = _f === void 0 ? {} : _f;
    var contextData = __assign(__assign({}, getContextTraits()), context);
    var featureFlag = LeapfrogProfileEventsEnabled;
    var _g = props.page_collection_title, page_collection_title = _g === void 0 ? "" : _g;
    var activationProps = {};
    if (page_collection_title)
        deeplySetProperty(window, "utag_data.collection_title", page_collection_title);
    // featureFlag might be enabled for mvpd events only
    if (isEventEnabled(featureFlag))
        return;
    // pageActivationCode truthy only during second screen activation flow
    var pageActivationCode = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getQueryParameter("code");
    if (pageActivationCode) {
        activationProps = getActivationProps();
        setSecondsScreenProfileCookie();
    }
    if (eventName === Events.AUTHETNTICATION_LOGGED_OUT) {
        deeplySetProperty(contextData, "traits.mvpd", "");
    }
    if (eventName === Events.GLOBAL_NAV_CLICKED && ((_c = window.utag_data) === null || _c === void 0 ? void 0 : _c.call_sign))
        deeplySetProperty(window, "utag_data.call_sign", null);
    var trackingProps = omitProperties(getDefaultEventProps({
        props: __assign(__assign({}, props), activationProps),
    }), ["account"]);
    var cleanedProps = cleanObject(trackingProps);
    var fireEvent = function () {
        var _a, _b;
        return ((_b = (_a = window.analytics) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : noop)(eventName, cleanedProps, contextData, cb);
    };
    if (typeof eventName === "string" &&
        eventName.length &&
        eventType !== "identify" &&
        eventName !== Events.PURCHASE_CTA_CLICKED) {
        var silenceLogOutput = (_d = window.DataLayer) === null || _d === void 0 ? void 0 : _d.isTestEnvironment();
        if (!silenceLogOutput)
            console.debug("Dispatching Segment event", eventName, {
                props: props,
                contextData: contextData,
            });
        fireCallbackWhenReady(fireEvent);
        return;
    }
    fireEvent();
};
export var formatBannerList = function (bannerData) {
    return bannerData.reduce(function (acc, banner, i) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var lastItem = i === bannerData.length - 1;
        var bannerType = getBannerType((_b = (_a = banner.items) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b[0]);
        var bannerHeadline = (_f = (_e = (_d = (_c = banner.items) === null || _c === void 0 ? void 0 : _c.member) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.headline) !== null && _f !== void 0 ? _f : "";
        var bannerName = (_k = (_j = (_h = (_g = banner.items) === null || _g === void 0 ? void 0 : _g.member) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.name) !== null && _k !== void 0 ? _k : "";
        var bannerTitle = (bannerHeadline || bannerName).toLowerCase();
        var ctaText = ((_p = (_o = (_m = (_l = banner.items) === null || _l === void 0 ? void 0 : _l.member) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.ctaText) !== null && _p !== void 0 ? _p : "").toLowerCase();
        return "" + acc + bannerType + ":" + bannerTitle + ":" + ctaText + (lastItem ? "" : ", ");
    }, "");
};
export var formatProps = function (props) {
    var e_1, _a;
    var invalidValues = [null, NaN];
    var newProps = props;
    try {
        for (var _b = __values(Object.entries(newProps)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            if (invalidValues.includes(value)) {
                newProps[key] = undefined;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return newProps;
};
export var generatePageName = function (_a) {
    var pageName = _a.pageName;
    return PAGE_NAME_PREFIX + ":" + pageName;
};
export var getAnonymousId = function () {
    var _a;
    var user = (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.user;
    return user ? user().anonymousId() : null;
};
export var getAuthTrackEvents = function () {
    var _a;
    var MVPDEvents = getMVPDEvents();
    var trackEvents = (_a = {},
        _a[AUTH_SUCCESS_EVENT] = function () {
            MVPDEvents.authenticationSelectProviderCompleted({});
            MVPDEvents.authenticationCompleted({});
        },
        _a[TV_PROVIDER_FEAT_LIST] = function () {
            getMVPDEvents(); // TODO: look into whether this block is needed
        },
        _a);
    return trackEvents;
};
export var getBannerDimensions = function (bannerType, isMobile) {
    if (bannerType === void 0) { bannerType = ""; }
    if (isMobile === void 0) { isMobile = false; }
    if (!bannerType)
        return "";
    if (isMobile)
        return "768x270";
    return bannerType === SKINNY ? "2080x210" : "1342x451";
};
export var getEndcardContentList = function (_a) {
    var _b = _a.endcardItems, endcardItems = _b === void 0 ? [] : _b, _c = _a.headerRecommended, headerRecommended = _c === void 0 ? "" : _c, _d = _a.headerUpNext, headerUpNext = _d === void 0 ? "" : _d;
    var firstEndcardDetails = getEndcardDetails(endcardItems[0] || {});
    var secondEndcardDetails = getEndcardDetails(endcardItems[1] || {});
    return headerUpNext + ":" + firstEndcardDetails + "||" + headerRecommended + ":" + secondEndcardDetails;
};
export var getEndCardPageEventProps = function (_a) {
    var _b = _a.endcardItems, endcardItems = _b === void 0 ? [] : _b, _c = _a.contentLength, contentLength = _c === void 0 ? 2 : _c;
    return __assign(__assign({}, getVideoPageRecs({ endcardItems: endcardItems, contentLength: contentLength })), { page_video_uid: getJoinedPageUId({ endcardItems: endcardItems, contentLength: contentLength }) });
};
export var getJoinedPageUId = function (_a) {
    var _b = _a.endcardItems, endcardItems = _b === void 0 ? [] : _b, _c = _a.contentLength, contentLength = _c === void 0 ? 2 : _c;
    var result = "";
    for (var i = 0; i < contentLength; i++) {
        if (i != 0) {
            result += "||";
        }
        var endCardItem = endcardItems === null || endcardItems === void 0 ? void 0 : endcardItems[i];
        result += endCardItem === null || endCardItem === void 0 ? void 0 : endCardItem.uID;
    }
    return result;
};
export var getVideoPageRecs = function (_a) {
    var _b, _c;
    var _d = _a.endcardItems, endcardItems = _d === void 0 ? [] : _d, _e = _a.contentLength, contentLength = _e === void 0 ? 2 : _e;
    var result = {
        end_card_page_recs_request_id: "",
        end_card_page_recs_source_id: "",
        end_card_page_recs_model_id: "",
        end_card_page_recs_result_set_id: "",
    };
    for (var i = 0; i < contentLength; i++) {
        var endCardItem = endcardItems === null || endcardItems === void 0 ? void 0 : endcardItems[i];
        var modelMetaData = (_c = (_b = endCardItem === null || endCardItem === void 0 ? void 0 : endCardItem.trackingData) === null || _b === void 0 ? void 0 : _b.properties) === null || _c === void 0 ? void 0 : _c.modelMetaData;
        if (modelMetaData) {
            if (i != 0) {
                for (var pageRecs in result) {
                    if (result.hasOwnProperty(pageRecs)) {
                        result[pageRecs] += "||";
                    }
                }
            }
            result["end_card_page_recs_request_id"] += modelMetaData.requestId;
            result["end_card_page_recs_source_id"] += modelMetaData.sourceId;
            result["end_card_page_recs_model_id"] += modelMetaData.modelId;
            result["end_card_page_recs_result_set_id"] += modelMetaData.resultSetId;
        }
    }
    return result;
};
export var getEndcardDetails = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.seriesName, seriesName = _c === void 0 ? "" : _c, _d = _b.name, name = _d === void 0 ? "" : _d, _e = _b.seasonNumber, seasonNumber = _e === void 0 ? "" : _e, _f = _b.episodeNumber, episodeNumber = _f === void 0 ? "" : _f, _g = _b.headline, headline = _g === void 0 ? "" : _g;
    var seasonNumFormat = seasonNumber ? "S" + seasonNumber : "";
    var episodeNumFormat = episodeNumber ? " E" + episodeNumber : "";
    var seasonEpisodeNum = seasonNumFormat
        ? "" + seasonNumFormat + episodeNumFormat + " "
        : "";
    var subtitle = "" + seasonEpisodeNum + (name || headline || "") || "";
    var title = seriesName;
    return title + ":" + subtitle;
};
export var getBannerType = function (panel, ref) {
    var _a, _b, _c, _d, _e, _f;
    if (ref === void 0) { ref = {}; }
    if (((_a = panel === null || panel === void 0 ? void 0 : panel.promoType) !== null && _a !== void 0 ? _a : "") ===
        ((_c = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.enums) === null || _c === void 0 ? void 0 : _c.PROMO_TYPE_MARKETING_VIDEO))
        return MARKETING_VIDEO;
    var imageName = (_e = (_d = panel === null || panel === void 0 ? void 0 : panel.images) === null || _d === void 0 ? void 0 : _d["desktop-promo"]) !== null && _e !== void 0 ? _e : "";
    var _g = __read(["skinny", "fat"].filter(function (bannerType) {
        return imageName.toLowerCase().includes(bannerType);
    }), 1), _h = _g[0], bannerType = _h === void 0 ? "" : _h;
    if (!bannerType) {
        // find 3 or 4 numbers followed by x, ×, or encoding %C3%97 followed by 3 or 4 numbers
        var _j = __read((_f = imageName.match(/\d{3,4}(x|×|%C3%97)\d{3,4}/)) !== null && _f !== void 0 ? _f : [], 1), dimensions = _j[0];
        if (dimensions) {
            var width = Number(dimensions.match(/^\d{3,4}/)[0]);
            var height = Number(dimensions.match(/\d{3,4}$/)[0]);
            return width / height > 5 ? SKINNY : FAT;
        }
        return getBannerTypeByRef(ref);
    }
    return bannerType === "skinny" ? SKINNY : FAT;
};
export var getBannerTypeByRef = function (_a) {
    var _b = _a.clientWidth, clientWidth = _b === void 0 ? 0 : _b, _c = _a.clientHeight, clientHeight = _c === void 0 ? 0 : _c;
    return (clientWidth / clientHeight > 5 ? SKINNY : FAT);
};
export var getCampaignCookieInfo = function () {
    var _a, _b;
    var preProdCookie = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getCookie({
        name: "campaignTraitInfo_preprod",
    });
    var prodCookie = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getCookie({
        name: "campaignTraitInfo",
    });
    return preProdCookie || prodCookie;
};
export var getCampaignValues = function () {
    var campaignTraits = getDataLayerCampaignCodes();
    return recursiveMerge(defaultCampaignValues, campaignTraits);
};
export var getSegmentContentUidString = function (collection) {
    var _a, _b;
    if (collection === void 0) { collection = {}; }
    return (_b = (_a = collection.items) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.reduce(function (str, item) {
        var _a = item.showCode, showCode = _a === void 0 ? "" : _a, _b = item.uID, uID = _b === void 0 ? "" : _b;
        var id = uID || showCode;
        return str ? str + ":" + id : id;
    }, "");
};
export var getContextBanners = function () { var _a, _b, _c; return Object.values((_c = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.segment) === null || _b === void 0 ? void 0 : _b.banners) !== null && _c !== void 0 ? _c : {}); };
// TODO: Refactor or combine with getContextTraits
export var getDataLayerCampaignCodes = function () {
    var _a;
    var campaignCodes = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.campaignCodes;
    return Object.keys(campaignCodes !== null && campaignCodes !== void 0 ? campaignCodes : {}).length
        ? campaignCodes
        : parseQueryUrl();
};
export var getContextTraits = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var mvpd = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.segment) === null || _b === void 0 ? void 0 : _b.mvpd;
    var anonymousId = getAnonymousId();
    if (!mvpd)
        mvpd = (_d = (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getMVPD()) !== null && _d !== void 0 ? _d : "";
    var validMvpd = (_e = !(mvpd === null || mvpd === void 0 ? void 0 : mvpd.includes("TempPass"))) !== null && _e !== void 0 ? _e : false;
    var _j = getCampaignValues(), campaign_tracking_code = _j.campaign_tracking_code, campaignTraits = __rest(_j, ["campaign_tracking_code"]);
    var lastAnonymousProfileId = getLastAnonymousProfileId();
    var lastKnownProfileId = getLastKnownProfileId();
    var dcgAccountData = (_f = window.DataLayer) === null || _f === void 0 ? void 0 : _f.getAccount();
    var dcgProfileId = dcgAccountData === null || dcgAccountData === void 0 ? void 0 : dcgAccountData.profileId;
    var privacyCookie = (_g = window.DataLayer) === null || _g === void 0 ? void 0 : _g.getCookie({
        name: "us_privacy",
    });
    var props = __assign(__assign({ appsflyer_id: "", mvpd: validMvpd ? mvpd : "", entitlements: getEntitlements({ excludePreviewPass: true }), lastKnownProfileId: lastKnownProfileId, isSignedIntoProfile: !!dcgAccountData, lastAnonymousProfileId: lastAnonymousProfileId, dcg_profile_id: dcgProfileId || "", us_privacy: privacyCookie !== null && privacyCookie !== void 0 ? privacyCookie : "", campaign_tracking_code: campaign_tracking_code || "" }, campaignTraits), { network_entitlement_list: getEntitlements({ excludePreviewPass: true }) });
    if ((_h = window.DataLayer) === null || _h === void 0 ? void 0 : _h.isNation()) {
        props.purchase_source = window.DataLayer.getPurchaseSource() || "";
    }
    return {
        traits: props,
        device: {
            id: getDeviceIdCookie(),
        },
        page: {
            url: window.location.href.split("?")[0],
        },
        Optimizely: {
            userId: anonymousId !== null && anonymousId !== void 0 ? anonymousId : "",
        },
    };
};
// TODO: cleanup
export var getDefaultEventProps = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    var props = _a.props;
    var argsPageType = (_b = props === null || props === void 0 ? void 0 : props.page_type) !== null && _b !== void 0 ? _b : null;
    var currentPageType = (_d = (_c = window.utag_data) === null || _c === void 0 ? void 0 : _c.page_type) !== null && _d !== void 0 ? _d : null;
    var windowPropsPageType = (_f = (_e = window.props) === null || _e === void 0 ? void 0 : _e.page_type) !== null && _f !== void 0 ? _f : null;
    var pageType = argsPageType ||
        currentPageType ||
        windowPropsPageType ||
        defaultGlobalPageProperties.page_type;
    var argsPageName = (_g = props === null || props === void 0 ? void 0 : props.page_name) !== null && _g !== void 0 ? _g : null;
    var currentPageName = (_j = (_h = window.utag_data) === null || _h === void 0 ? void 0 : _h.page_name) !== null && _j !== void 0 ? _j : null;
    var pageName = argsPageName || currentPageName;
    var campaignTraits = getCampaignValues();
    var pageTitle = (_l = (_k = window.utag_data) === null || _k === void 0 ? void 0 : _k.page_content_title) !== null && _l !== void 0 ? _l : null;
    var pageLoginState = getPageLoginState();
    var pageTestName = (_m = window === null || window === void 0 ? void 0 : window.amplitude) === null || _m === void 0 ? void 0 : _m.pageTestName;
    var pageContentPersonality = ((_o = window.DataLayer) === null || _o === void 0 ? void 0 : _o.isNation()) &&
        ((_r = (_q = (_p = window.context) === null || _p === void 0 ? void 0 : _p.segment) === null || _q === void 0 ? void 0 : _q.contentPersonality) !== null && _r !== void 0 ? _r : null);
    var pageBannerCount = getContextBanners().length;
    var pageBannerList = formatBannerList(getContextBanners());
    var favoritesData = (_s = window.DataLayer) === null || _s === void 0 ? void 0 : _s.getFavorites();
    var cleanedProps = cleanObject(__assign(__assign(__assign(__assign({}, getPageContentLevels(props)), getTimePartingInfo()), (argsPageType !== SEGMENT_PAGE_TYPE_CCPA &&
        getFavoritesProps(favoritesData))), { page_test_name: pageTestName, page_content_title: pageTitle, page_content_personality: pageContentPersonality, page_banner_count: pageBannerCount, page_banner_list: pageBannerList, page_name: pageName, page_type: pageType }));
    var mergedProps = recursiveMerge({
        page_is_dark_mode: false,
        page_login_state: pageLoginState,
    }, defaultCampaignValues, defaultGlobalPageProperties, campaignTraits, props, cleanedProps);
    return mergedProps;
};
export var getDeviceIdCookie = function () { var _a; return (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getCookie({ name: SEGMENT_DEVICE_ID_COOKIE }); };
export var isDetail = function (data, index) {
    return isSeriesDetail(data, index) || isMovieDetail(data, index);
};
export var getDetailFindReferrer = function (data) {
    return isDetail(data, 0) && isFind(data, 1);
};
export var getDetailSearchReferrer = function (data) {
    return isDetail(data, 0) && isSearch(data, 1);
};
export var getDetailCollectionReferrer = function (data) {
    return isDetail(data, 0) && isCollection(data, 1);
};
export var getDetailDetailReferrer = function (data) {
    return isDetail(data, 0) && isDetail(data, 1);
};
export var getDetailLiveReferrer = function (data) {
    return isDetail(data, 0) && isLive(data, 1);
};
export var getContinuousPlayReferrer = function (data) {
    return isContinuousPlay(data, 0);
};
export var getDeeplinkReferrer = function (data) {
    return isDeeplink(data, 0);
};
export var getEndcardReferrer = function (data) {
    return isEndcard(data, 0);
};
export var getHomeReferrer = function (data) { return isHome(data, 0); };
export var getVodSectionReferrer = function (data) {
    return isVodSection(data, 0);
};
export var getEntitlements = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var excludePreviewPass = _a.excludePreviewPass;
    var entitlementOverride = hasEntitlementOverride();
    var entitlements = (_d = (_c = (_b = window.context) === null || _b === void 0 ? void 0 : _b.segment) === null || _c === void 0 ? void 0 : _c.entitlements) !== null && _d !== void 0 ? _d : "";
    if (!entitlements) {
        var authCookie = (_e = window.DataLayer) === null || _e === void 0 ? void 0 : _e.getCookie({
            name: (_g = (_f = window.DataLayer.enums) === null || _f === void 0 ? void 0 : _f.MVPD_COOKIE) !== null && _g !== void 0 ? _g : "",
        });
        var preauthorizedResources = (_h = authCookie === null || authCookie === void 0 ? void 0 : authCookie.preauthorizedResources) !== null && _h !== void 0 ? _h : [];
        preauthorizedResources.sort(sortEntitlements);
        entitlements = preauthorizedResources.join(",");
    }
    if (entitlementOverride)
        return entitlementOverride;
    if (excludePreviewPass) {
        var mvpd = (_k = (_j = window.context) === null || _j === void 0 ? void 0 : _j.segment) === null || _k === void 0 ? void 0 : _k.mvpd;
        if (!mvpd)
            mvpd = (_m = (_l = window.DataLayer) === null || _l === void 0 ? void 0 : _l.getMVPD()) !== null && _m !== void 0 ? _m : "";
        var validMvpd = !((_o = window.DataLayer) === null || _o === void 0 ? void 0 : _o.isPreviewPass(mvpd));
        return validMvpd ? entitlements : "";
    }
    return entitlements;
};
export var getFavoritesEvents = function () {
    var generateFavoriteProps = function (data) {
        var actionLocation = data.actionLocation, _a = data.seriesName, seriesName = _a === void 0 ? "" : _a, favoritesProps = data.favoritesProps, _b = data.showID, showID = _b === void 0 ? "" : _b;
        var itemTitle = seriesName.toLowerCase();
        var isPersonality = /^meet-/.test(showID);
        return __assign(__assign({}, favoritesProps), { page_action_location: actionLocation, page_item_title: itemTitle, page_favorite_type: isPersonality ? "personality" : "series", page_favorite_update: seriesName });
    };
    return {
        addFavorite: function (props) {
            var page_item_title = props.page_item_title;
            handleAnalytics({
                event: Events.ADDED_FAVORITES,
                payload: __assign(__assign({}, generateFavoriteProps(props)), { page_item_title: page_item_title }),
            });
        },
        removeFavorite: function (props) {
            var page_item_title = props.page_item_title;
            handleAnalytics({
                event: Events.REMOVED_FAVORITES,
                payload: __assign(__assign({}, generateFavoriteProps(props)), { page_item_title: page_item_title }),
            });
        },
    };
};
export var getLastAnonymousProfileId = function () {
    var _a, _b, _c;
    var pageActivationCode = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getQueryParameter("code");
    var secondScreenAnonId = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getCookie({
        name: SECOND_SCREEN_ANONYMOUS_ID,
    });
    return pageActivationCode
        ? secondScreenAnonId
        : (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getCookie({
            name: SegmentProfileIdCookies.LAST_KNOWN_ANONYMOUS,
        });
};
export var getLastKnownProfileId = function () {
    var _a, _b;
    var accountCookie = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getAccount();
    var dcgProfileId = accountCookie === null || accountCookie === void 0 ? void 0 : accountCookie.profileId;
    var lastKnownProfileId = (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.getCookie({
        name: SegmentProfileIdCookies.LAST_KNOWN,
    });
    return lastKnownProfileId || dcgProfileId || "";
};
export var getLivePageName = function (_a) {
    var location = _a.location, previousPath = _a.previousPath;
    var referrerPath = location === null || location === void 0 ? void 0 : location.pathname;
    var pageName = "";
    if (!referrerPath.includes("channel")) {
        pageName = COLLECTION_LIVE_TV;
    }
    else if (previousPath === "/") {
        pageName = COLLECTION_HOME;
    }
    else if (previousPath.match(/^\/(news)(\/)?(.*)$/)) {
        pageName = COLLECTION_NEWS;
    }
    else if (previousPath.match(/^\/(local)(\/)?(.*)$/)) {
        pageName = COLLECTION_LOCAL;
    }
    return pageName;
};
export var getLiveViewedVideo = function (_a) {
    var video = _a.video, prevVideo = _a.prevVideo, segmentSourceType = _a.segmentSourceType;
    if (segmentSourceType === SegmentSources.AUTOPLAY)
        return prevVideo;
    return video;
};
export var getMVPDEvents = function () {
    var _a, _b;
    var currentPageName = (_b = (_a = window.utag) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.page_name;
    var pageName = currentPageName || defaultGlobalPageProperties.page_name;
    return {
        authenticationStarted: function (props) {
            var mvpdProps = __assign(__assign(__assign({}, props), getActivationProps()), { page_name: pageName });
            handleAnalytics({
                event: Events.AUTHENTICATION_STARTED,
                payload: mvpdProps,
            });
        },
        authenticationCompleted: function (props) {
            var mvpdProps = __assign(__assign(__assign({}, props), getActivationProps()), { page_name: pageName });
            handleAnalytics({
                event: Events.AUTHENTICATION_COMPLETED,
                payload: mvpdProps,
            });
        },
        previewPassStarted: function (props) {
            var mvpdProps = __assign(__assign({}, props), { page_name: pageName });
            handleAnalytics({
                event: Events.PRIVIEW_PASS_STARTED,
                payload: mvpdProps,
            });
        },
        mvpdPreviewPassExpired: function (props) {
            var mvpdProps = __assign(__assign({}, props), { page_name: pageName });
            handleAnalytics({
                event: Events.PREVIEW_PASS_EXPIRED,
                payload: mvpdProps,
            });
        },
        authenticationSelectProviderStarted: function (props) {
            var mvpdProps = __assign(__assign(__assign({}, props), getActivationProps()), { page_name: pageName });
            handleAnalytics({
                event: Events.AUTHENTICATON_SELECT_PROVIDER_STARTED,
                payload: mvpdProps,
            });
        },
        authenticationSelectProviderError: function (props) {
            var mvpdProps = __assign(__assign({}, getActivationProps()), { page_name: pageName, page_error_description: props === null || props === void 0 ? void 0 : props.description, page_error_type: props === null || props === void 0 ? void 0 : props.type });
            handleAnalytics({
                event: Events.AUTHENTICATON_SELECT_PROVIDER_ERROR,
                payload: mvpdProps,
            });
        },
        authenticationSelectProviderCompleted: function (props) {
            var mvpdProps = __assign(__assign(__assign({}, props), getActivationProps()), { page_name: pageName, page_action_type: props === null || props === void 0 ? void 0 : props.actionType });
            handleAnalytics({
                event: Events.AUTHENTICATON_SELECT_PROVIDER_COMPLETED,
                payload: mvpdProps,
            });
        },
        authenticationLoggedOut: function (props) {
            var mvpdProps = __assign(__assign({}, props), { page_name: pageName });
            handleAnalytics({
                event: Events.AUTHETNTICATION_LOGGED_OUT,
                payload: mvpdProps,
            });
        },
    };
};
export var getPageContentLevels = function (props) {
    var _a;
    var pageName = (props === null || props === void 0 ? void 0 : props.page_name) || ((_a = window.utag_data) === null || _a === void 0 ? void 0 : _a.page_name);
    if (pageName) {
        var splitPageLevels = pageName.split(":");
        return {
            page_content_level_1: splitPageLevels.slice(0, 3).join(":"),
            page_content_level_2: splitPageLevels.slice(0, 4).join(":"),
            page_content_level_3: splitPageLevels.slice(0, 5).join(":"),
            page_content_level_4: splitPageLevels.slice(0, 6).join(":"),
        };
    }
    return {};
};
export var getPageReferrerDataFromStorage = function () {
    var _a;
    var defaultValue = [];
    var pageReferrerData = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getSessionStorage({
        key: SESSION_STORAGE_REFERRER_TRACKING,
    });
    return pageReferrerData ? JSON.parse(pageReferrerData) : defaultValue;
};
export var getPageStartSource = function () { var _a, _b, _c; return (_c = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.segment) === null || _b === void 0 ? void 0 : _b.authStartSource) !== null && _c !== void 0 ? _c : SegmentPageStartSources.GENERAL; };
export var getPageViewProps = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    // Use utag window data for data when tracking page account events from overlays
    // otherwise use existing data stored in the window.utag_data
    var utagData = data !== null && data !== void 0 ? data : window.utag_data;
    return {
        name: (_a = utagData === null || utagData === void 0 ? void 0 : utagData.page_name) !== null && _a !== void 0 ? _a : "",
        primary_business_unit: (_b = utagData === null || utagData === void 0 ? void 0 : utagData.primary_bu) !== null && _b !== void 0 ? _b : "",
        secondary_business_unit: (_c = utagData === null || utagData === void 0 ? void 0 : utagData.secondary_bu) !== null && _c !== void 0 ? _c : "",
        app_name: (_d = utagData === null || utagData === void 0 ? void 0 : utagData.app_name) !== null && _d !== void 0 ? _d : "",
        app_platform: (_e = utagData === null || utagData === void 0 ? void 0 : utagData.app_platform) !== null && _e !== void 0 ? _e : "",
        app_version: APP_VERSION,
        page_content_level_1: (_f = utagData === null || utagData === void 0 ? void 0 : utagData.sc_content_1) !== null && _f !== void 0 ? _f : "",
        page_content_level_2: (_g = utagData === null || utagData === void 0 ? void 0 : utagData.sc_content_2) !== null && _g !== void 0 ? _g : "",
        page_content_level_3: (_h = utagData === null || utagData === void 0 ? void 0 : utagData.sc_content_3) !== null && _h !== void 0 ? _h : "",
        page_content_level_4: (_j = utagData === null || utagData === void 0 ? void 0 : utagData.sc_content_4) !== null && _j !== void 0 ? _j : "",
    };
};
export var getReferrer = function (_a) {
    var _b;
    var prevSegmentReferrer = _a.prevSegmentReferrer;
    var noneReferrer = (_b = {},
        _b[NAME] = NONE,
        _b[TYPE] = NONE,
        _b[POSITION] = NONE,
        _b);
    var referrerDataFromStorage = getReferrerDataFromStorage();
    var referrerType = referrerDataFromStorage === null || referrerDataFromStorage === void 0 ? void 0 : referrerDataFromStorage[TYPE];
    switch (referrerType) {
        case CONTINUOUS_PLAY:
        case ENDCARD:
        case VOD_SECTION:
            return prevSegmentReferrer;
        case DEEPLINK:
        case HOME:
            return noneReferrer;
        default:
            return referrerDataFromStorage;
    }
};
export var getPodId = function (data) { var _a, _b; return (((_b = (_a = data === null || data === void 0 ? void 0 : data.chapter) === null || _a === void 0 ? void 0 : _a.index) !== null && _b !== void 0 ? _b : 0) + 1).toString(); };
export var getReferrerDataFromStorage = function () {
    var _a;
    var _b, _c;
    var referrerData = getPageReferrerDataFromStorage();
    var isDetailFindReferrer = getDetailFindReferrer(referrerData);
    var isDetailSearchReferrer = getDetailSearchReferrer(referrerData);
    var isDetailCollectionReferrer = getDetailCollectionReferrer(referrerData);
    var isDetailDetailReferrer = getDetailDetailReferrer(referrerData);
    var isDetailLiveReferrer = getDetailLiveReferrer(referrerData);
    var isContinuousPlayReferrer = getContinuousPlayReferrer(referrerData);
    var isDeeplinkReferrer = getDeeplinkReferrer(referrerData);
    var isEndcardReferrer = getEndcardReferrer(referrerData);
    var isHomeReferrer = getHomeReferrer(referrerData);
    var isVodSectionReferrer = getVodSectionReferrer(referrerData);
    var isReferrerFirstIndex = isDetailFindReferrer ||
        isDetailSearchReferrer ||
        isDetailCollectionReferrer ||
        isDetailDetailReferrer ||
        isDetailLiveReferrer
        ? 1
        : null;
    var isReferrerZeroIndex = isContinuousPlayReferrer ||
        isDeeplinkReferrer ||
        isEndcardReferrer ||
        isHomeReferrer ||
        isVodSectionReferrer
        ? 0
        : null;
    var referrerDataLocation = isReferrerFirstIndex || isReferrerZeroIndex;
    if (referrerDataLocation !== null) {
        var id = (_b = referrerData === null || referrerData === void 0 ? void 0 : referrerData[referrerDataLocation]) === null || _b === void 0 ? void 0 : _b.name;
        var data = (_c = referrerData === null || referrerData === void 0 ? void 0 : referrerData[referrerDataLocation]) === null || _c === void 0 ? void 0 : _c.data;
        var referrerName = referrerPageMap[id];
        return __assign((_a = {}, _a[TYPE] = referrerName || id, _a), data);
    }
    return null;
};
export function getSegmentLiveCollectionCount(panels) {
    var _a, _b;
    return (_b = (_a = panels === null || panels === void 0 ? void 0 : panels.member) === null || _a === void 0 ? void 0 : _a.filter(function (panel) { return (panel === null || panel === void 0 ? void 0 : panel.panelType) !== "listing"; })) === null || _b === void 0 ? void 0 : _b.length;
}
export var getSegmentModelMetadata = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ({
        page_recs_configuration_id: (_d = (_c = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.segment) === null || _b === void 0 ? void 0 : _b.modelMetadata) === null || _c === void 0 ? void 0 : _c.configurationId) !== null && _d !== void 0 ? _d : "",
        page_recs_result_set_id: (_h = (_g = (_f = (_e = window.context) === null || _e === void 0 ? void 0 : _e.segment) === null || _f === void 0 ? void 0 : _f.modelMetadata) === null || _g === void 0 ? void 0 : _g.resultSetId) !== null && _h !== void 0 ? _h : "",
        page_recs_source_id: (_m = (_l = (_k = (_j = window.context) === null || _j === void 0 ? void 0 : _j.segment) === null || _k === void 0 ? void 0 : _k.modelMetadata) === null || _l === void 0 ? void 0 : _l.sourceId) !== null && _m !== void 0 ? _m : "",
    });
};
export var getSegmentPageCollectionIdList = function (collections, event) {
    if (event === Events.COLLECTION_ITEMS_AVAILABLE) {
        return collections.reduce(function (str, item) { return "" + str + (str ? "," : "") + item.id; }, "");
    }
    return collections.reduce(function (str, item) {
        var _a;
        var contentUids = (_a = item === null || item === void 0 ? void 0 : item.contentUids) !== null && _a !== void 0 ? _a : getSegmentContentUidString(item);
        var _b = item.id, id = _b === void 0 ? "" : _b;
        var itemStr = id ? id + ":" + contentUids : "";
        return str ? str + "," + itemStr : "" + itemStr;
    }, "");
};
export var getSegmentOptimizelyData = function () {
    var _a;
    var optimizelySegmentStorage = (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.getLocalStorage({
        key: OPTIMIZELY_SEGMENT_LOCAL_STORAGE,
    });
    return optimizelySegmentStorage ? JSON.parse(optimizelySegmentStorage) : {};
};
export var getSignOutStartSource = function (_a) {
    var networkUpsellPage = _a.networkUpsellPage, pathname = _a.pathname, routeParams = _a.routeParams;
    var path = pathname || "";
    if (path.replace(/\//g, "") === networkUpsellPage.replace(/\//g, "")) {
        return "Marketing Page";
    }
    if (path === "/")
        return "Home Page";
    if (routeParams === null || routeParams === void 0 ? void 0 : routeParams.showId)
        return "Series Detail Page";
    if (routeParams === null || routeParams === void 0 ? void 0 : routeParams.movieId)
        return "Movie Detail Page";
    if (routeParams === null || routeParams === void 0 ? void 0 : routeParams.articleId)
        return "Article Page";
    if (path.includes("/shows"))
        return "Shows Page";
    if (path.includes("/movies"))
        return "Movies Page";
    if (path.includes("/watch"))
        return "Watch Page";
    if (path.includes("/live/"))
        return "Live Page";
    return false;
};
export var getSourceName = function (_a) {
    var _b, _c;
    var data = _a.data, type = _a.type;
    switch (type) {
        case SegmentSources.HOME: {
            var contextHomeLocation = "context.segment.home";
            var contextHome = (_c = (_b = window.context) === null || _b === void 0 ? void 0 : _b.segment) === null || _c === void 0 ? void 0 : _c.home;
            var sourceName = contextHome === null || contextHome === void 0 ? void 0 : contextHome.sourceName;
            var sourceHome = (contextHome === null || contextHome === void 0 ? void 0 : contextHome.isLive) ? SegmentSources.HOME : null;
            var homeData = sourceName || sourceHome || null;
            if (homeData)
                deeplySetProperty(window, contextHomeLocation, null);
            return homeData;
        }
        case SegmentSources.DETAIL:
            return data === null || data === void 0 ? void 0 : data.showCode;
        case SegmentSources.LIVE:
            return SegmentSources.LIVE;
        case SegmentSources.VOD_SECTION:
        case SegmentSources.AUTOPLAY:
        case SegmentSources.END_SLATE: {
            return concatSourceNameData({ data: data });
        }
        default: {
            return window.location.href;
        }
    }
};
export var getSourceType = function (_a) {
    var autoplay = _a.autoplay, epg = _a.epg, endslate = _a.endslate, homeUrl = _a.homeUrl, path = _a.path, vodThumbnails = _a.vodThumbnails;
    var isHome = path === homeUrl;
    var isLive = epg || (path !== null && path !== void 0 ? path : "").includes("/live");
    var isDeeplink = window.location.pathname === path;
    if (isHome)
        return SegmentSources.HOME;
    if (vodThumbnails)
        return SegmentSources.VOD_SECTION;
    if (endslate)
        return SegmentSources.END_SLATE;
    if (autoplay)
        return SegmentSources.AUTOPLAY;
    if (isLive)
        return SegmentSources.LIVE;
    if (isDeeplink)
        return SegmentSources.DEEPLINK;
    return SegmentSources.DETAIL;
};
/**
 * ### handleSegmentAnalytics
 * accepts payloads for specified Segment events, as well as callbacks for these dispatched events.
 * @param {() => void} callback - a callback that will be invoked after the event is dispatched.
 * @param {string} event - the name of the event.
 * @param {Object} payload - AnyObject containing a payload of properties.
 */
export function handleSegmentAnalytics(_a) {
    var callback = _a.callback, event = _a.event, payload = _a.payload;
    switch (EventTypeMap[event]) {
        case EventTypes.PAGE: {
            var _b = payload.pageName, pageName = _b === void 0 ? "" : _b, pageType = payload.pageType;
            // Todo: refactor callPageEvent
            callPageEvent({
                eventName: SegmentEventStrings[event],
                pageName: pageName,
                props: __assign(__assign({}, payload), { pageType: pageType }),
                featureFlag: true,
            });
            break;
        }
        case EventTypes.TRACK: {
            fireEvent({
                eventType: SegmentEventTypes.TRACK_EVENT,
                eventName: SegmentEventStrings[event],
                props: payload,
                cb: callback,
            });
            break;
        }
        default:
    }
}
export var initDeviceIdCookie = function (_a) {
    var deviceId = _a.deviceId, expires = _a.expires, generateCookie = _a.generateCookie;
    var deviceIdCookie = getDeviceIdCookie();
    if (!deviceIdCookie) {
        deeplySetProperty(window, "utag_data.ajs_anonymous_id", deviceId);
        generateCookie(SEGMENT_DEVICE_ID_COOKIE, deviceId, expires);
    }
};
// TODO: refactor/combine isEventEnabled and isTrackingEnabledForEvent
export var isEventEnabled = function (featureFlag) {
    return typeof featureFlag !== "undefined" && !featureFlag;
};
// TODO: refactor/combine isEventEnabled and isTrackingEnabledForEvent
export var isTrackingEnabledForEvent = function (name) {
    var _a;
    if (!name)
        return false;
    var withTveEventsToDisable = [];
    var withoutTveEventsToDisable = [LABEL_TV_PROVIDER_SIGN_OUT_PAGE_VIEW];
    var disabledEvents = ((_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.isTveEnabled())
        ? withTveEventsToDisable
        : withoutTveEventsToDisable;
    var isEventEnabled = disabledEvents.indexOf(name) === -1;
    return isEventEnabled;
};
export var setContentPersonality = function (personality) {
    if (personality) {
        var contentPersonality = personality.toString().replace(/-/g, " ");
        deeplySetProperty(window, "context.segment.contentPersonality", contentPersonality);
    }
    else {
        deeplySetProperty(window, "context.segment.contentPersonality", undefined);
    }
};
export var setLoaded = function () {
    // Check to see if analytics.js has been loaded
    var checkIfLoaded = setInterval(function () {
        var _a;
        var analyticsReady = (_a = window.analytics) !== null && _a !== void 0 ? _a : false;
        if (analyticsReady) {
            deeplySetProperty(window, "context.segment.loaded", true);
            clearInterval(checkIfLoaded);
        }
    }, 500);
};
export var setPageStartSource = function (_a) {
    var previewPassExpired = _a.previewPassExpired, previewPassSignIn = _a.previewPassSignIn, MVPDIncomplete = _a.MVPDIncomplete, isHeader = _a.isHeader;
    var setPageStartSource = function (value) {
        return deeplySetProperty(window, "context.segment.authStartSource", value);
    };
    if (previewPassSignIn)
        setPageStartSource(PP_SIGNIN);
    if (previewPassExpired)
        setPageStartSource(PP_EXPIRATION);
    if (isHeader)
        setPageStartSource(SETTINGS);
    if (MVPDIncomplete)
        setPageStartSource(MVPDINCOMPLETE);
};
export var setEntitlements = function (entitlementsList) {
    return deeplySetProperty(window, "context.segment.entitlements", entitlementsList);
};
export var setSegmentOptimizelyData = function (_a) {
    var _b;
    var segmentCampaignData = _a.segmentCampaignData;
    var testData = __assign(__assign({}, getSegmentOptimizelyData()), segmentCampaignData);
    (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.setLocalStorage({
        key: OPTIMIZELY_SEGMENT_LOCAL_STORAGE,
        value: JSON.stringify(testData),
    });
};
export var getSegmentOptimizelyString = function () {
    var _a, _b, _c;
    var experiments = getSegmentOptimizelyData();
    var removeUndefinedString = function (str) {
        return str.includes("undefined") || str.length <= 1 ? "" : str;
    };
    if (Object.keys(experiments !== null && experiments !== void 0 ? experiments : {}).length) {
        return Object.keys(experiments)
            .map(function (key) {
            var _a = experiments[key], _b = _a.experimentName, experimentName = _b === void 0 ? "" : _b, _c = _a.variationName, variationName = _c === void 0 ? "" : _c, _d = _a.campaignName, campaignName = _d === void 0 ? "" : _d;
            return removeUndefinedString(experimentName.trim() + ":" + variationName.trim());
        })
            .filter(Boolean)
            .join(",");
    }
    return removeUndefinedString((_c = (_b = (_a = window.context) === null || _a === void 0 ? void 0 : _a.optimizely) === null || _b === void 0 ? void 0 : _b.pageTestName) !== null && _c !== void 0 ? _c : "");
};
/**
 * ### parseQueryUrl
 * checks the url for marketing campaign-related query params.
 */
export var parseQueryUrl = function () {
    var _a;
    var _b, _c;
    var queryString = window.location.search;
    var campaignCookie = getCampaignCookieInfo();
    var segmentCampaign = "cmpid";
    var intPrefix = queryString.includes("int_") ? "int_" : "";
    var propertyNames = (_a = {
            cmpid: "campaign_" + intPrefix + "tracking_code"
        },
        _a[intPrefix + "org"] = "campaign_" + intPrefix + "organization",
        _a[intPrefix + "ag"] = "campaign_" + intPrefix + "agency",
        _a[intPrefix + "mc"] = "campaign_" + intPrefix + "marketing_channel",
        _a[intPrefix + "src"] = "campaign_" + intPrefix + "source",
        _a[intPrefix + "cmp"] = "campaign_" + intPrefix + "name",
        _a[intPrefix + "add"] = "campaign_" + intPrefix + "additional",
        _a);
    var params = {};
    var fullQuery = queryString.substring(1);
    var includesCmpid = fullQuery.includes(segmentCampaign + "=");
    var sessionStorage = window.sessionStorage;
    if (includesCmpid) {
        // valid campaign codes
        var _d = __read(fullQuery.match(/cmpid(.*)/), 1), campaignString = _d[0];
        params[propertyNames[segmentCampaign]] = campaignString;
        var campaignCodes = campaignString.split("::");
        if (campaignCodes.length > 1) {
            campaignCodes.forEach(function (codes) {
                var keyValuesPair = codes.split("=");
                if (keyValuesPair.length === 2) {
                    var _a = __read(keyValuesPair, 2), key = _a[0], value = _a[1];
                    params[propertyNames[key]] = value;
                }
            });
        }
        if (sessionStorage) {
            (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.setSessionStorage({
                key: "campaignInfo",
                value: JSON.stringify(params),
            });
        }
    }
    else if (sessionStorage) {
        var campaignInfo = (_c = window.DataLayer) === null || _c === void 0 ? void 0 : _c.getSessionStorage({
            key: "campaignInfo",
        });
        if (campaignInfo)
            return setDataLayerCampaignCodes(JSON.parse(campaignInfo));
    }
    else if (campaignCookie) {
        removeCampaignCookieInfo();
        return setDataLayerCampaignCodes(campaignCookie);
    }
    return setDataLayerCampaignCodes(params);
};
export var removeCampaignCookieInfo = function () {
    var _a, _b;
    (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.removeCookie({ key: "campaignTraitInfo_preprod" });
    (_b = window.DataLayer) === null || _b === void 0 ? void 0 : _b.removeCookie({ key: "campaignTraitInfo" });
};
export var removeUserIdCookie = function () { var _a; return (_a = window.DataLayer) === null || _a === void 0 ? void 0 : _a.removeCookie({ key: "ajs_user_id" }); };
export function segmentReadyCallback() {
    pushProfileIdsToGoogleDataLayer();
}
export var setDataLayerCampaignCodes = function (codes) {
    if (window.DataLayer)
        window.DataLayer.campaignCodes = codes;
    return codes;
};
export var setContextMVPD = function (mvpd) {
    return deeplySetProperty(window, "context.segment.mvpd", mvpd);
};
export var setContextSourceLive = function (isLive) {
    return deeplySetProperty(window, "context.segment.home.isLive", isLive);
};
export var setRestartedPlaybackGlobal = function (val) {
    return deeplySetProperty(window, SegmentPlayerContextStrings.RESTARTED_PLAYBACK, val);
};
export var setResumedPlaybackGlobal = function (val) {
    return deeplySetProperty(window, SegmentPlayerContextStrings.RESUMED_PLAYBACK, val);
};
export var setSegmentModelMetadata = function (data) {
    return deeplySetProperty(window, "context.segment.modelMetadata", data);
};
export var setSecondsScreenProfileCookie = function () {
    var lastKnownProfileId = getLastKnownProfileId();
    var network = window.DataLayer.isNation() ? "foxnews" : "fox";
    var dateToIncrement = new Date();
    window.DataLayer.setCookie({
        name: SECOND_SCREEN_PROFILE_ID,
        value: lastKnownProfileId,
        options: {
            domain: "." + network + ".com",
            expires: new Date(dateToIncrement.setSeconds(dateToIncrement.getSeconds() + 100)),
            path: "/",
            sameSite: "lax",
        },
    });
};
export var sortEntitlements = function (a, b) {
    return a.toLowerCase().localeCompare(b.toLowerCase());
};
export var updateBannerData = function (panels) {
    var banners = panels.filter(function (panel) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var promoType = (_c = (_b = (_a = panel === null || panel === void 0 ? void 0 : panel.items) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.promoType;
        return (promoType === ((_e = (_d = window.DataLayer) === null || _d === void 0 ? void 0 : _d.enums) === null || _e === void 0 ? void 0 : _e.PROMO_TYPE_MARKETING_VIDEO) ||
            promoType === ((_g = (_f = window.DataLayer) === null || _f === void 0 ? void 0 : _f.enums) === null || _g === void 0 ? void 0 : _g.PROMO_TYPE_INSET) ||
            promoType === ((_j = (_h = window.DataLayer) === null || _h === void 0 ? void 0 : _h.enums) === null || _j === void 0 ? void 0 : _j.PROMO_TYPE_LEAD));
    });
    deeplySetProperty(window, "context.segment.banners", banners.map(function (panel) { return panel; }));
};
var testCommit = {};
